module.exports = __webpack_public_path__ + "static/media/step9.3c984500.png";